import { render, staticRenderFns } from "./PrincipalEditDialog.vue?vue&type=template&id=00894286&scoped=true"
import script from "./PrincipalEditDialog.vue?vue&type=script&lang=js"
export * from "./PrincipalEditDialog.vue?vue&type=script&lang=js"
import style0 from "./PrincipalEditDialog.vue?vue&type=style&index=0&id=00894286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00894286",
  null
  
)

export default component.exports